import db from '@mobile/db/db';

const storeName = 'drafts';

export default {

    async count() {
        await db.open();
        return await db.count(storeName);
    },

    async getAll() {
        await db.open();
        return await db.getAll(storeName);
    },

    async getAllForUser(userId) {
        await db.open();

        const result = [];

        let cursor = await db
            .transaction(storeName)
            .store
            .index('user_id')
            .openCursor(IDBKeyRange.only(userId));

        while (cursor) {
            result.push(cursor.value);
            cursor = await cursor.continue();
        }

        return result;
    },

    async get(key) {
        await db.open();
        return await db.get(storeName, key);
    },

    async put(inspection) {
        await db.open();
        return await db.put(storeName, inspection);
    },

    async delete(key) {
        return await db.delete(storeName, key);
    },

};
